<template>
  <a
    :href="href"
    class="inline-block px-4 py-3 rounded border border-black border-solid
      items-center justify-center no-underline outline-none
      cursor-pointer w-full box-border"
    @click="handleClickEvent($event)"
    @click.native="handleClickEvent($event)">
    <div
      class="flex items-center justify-center text-center">
      <img
        class="payment-methods__sprite"
        :src="copySvg"
        :alt="$t('loginWithApple')">
    </div>
  </a>
</template>

<script>
import events from "@/events";
import appleLoginCopyEn from "@/component-library/apple-login-button/copy/en.svg";
import appleLoginCopyDe from "@/component-library/apple-login-button/copy/de.svg";

export default {
  name: "ButtonLink",
  props: {
    eventCategory: { type: String, default: "body-20211125-apple_login_button" },
    userDataJson: { type: String, default: "" },
    lastPageBeforeLoginValue: { type: String, default: "" }
  },
  data() {
    return {
      appleLoginCopyEn,
      appleLoginCopyDe
    };
  },
  computed: {
    copySvg() {
      if (this.$i18n.locale === "de") {
        return this.appleLoginCopyDe;
      } else {
        return this.appleLoginCopyEn;
      }
    },
    href() {
      let url = `/${this.$i18n.locale}/nc/apple_login?user_data=${this.userDataJson}`;
      if (this.lastPageBeforeLoginValue) {
        url = `${url}&last_page_before_login=${this.lastPageBeforeLoginValue}`;
      }
      return url;
    }
  },
  methods: {
    handleClickEvent(event) {
      events.track(this.eventCategory, "1-click");

      this.$emit("click", event);
    }
  },
  i18n: {
    messages: {
      en: {
        loginWithApple: "Continue with Apple"
      },
      de: {
        loginWithApple: "Mit Apple anmelden"
      }
    }
  }
};
</script>
